import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { styled, useTheme } from '../../styles';
import { Box, Column, Flex } from '../layout';
const CornerPad = styled(Box)(({ theme, rotation }) => ({
    position: 'absolute',
    width: '33px',
    height: '33px',
    borderTop: `1px solid ${theme.colors.grey30}`,
    borderLeft: `1px solid ${theme.colors.grey30}`,
    transform: `rotate(${rotation}deg)`,
}));
const LogoBox = styled(Flex)(({ height }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    height: height,
    width: '200px',
    position: 'relative',
    overflow: 'hidden',
}));
// source: https://stackoverflow.com/questions/27277641/create-a-checkered-background-using-css
const CheckeredBackground = styled(Box) `
    background: linear-gradient(
            45deg,
            rgba(0, 0, 0, 0.0980392) 25%,
            transparent 25%,
            transparent 75%,
            rgba(0, 0, 0, 0.0980392) 75%,
            rgba(0, 0, 0, 0.0980392) 0
        ),
        linear-gradient(
            45deg,
            rgba(0, 0, 0, 0.0980392) 25%,
            transparent 25%,
            transparent 75%,
            rgba(0, 0, 0, 0.0980392) 75%,
            rgba(0, 0, 0, 0.0980392) 0
        ),
        white;
    background-repeat: repeat, repeat;
    background-position: 0px 0, 5px 5px;
    transform-origin: 0 0 0;
    background-origin: padding-box, padding-box;
    background-clip: border-box, border-box;
    background-size: 10px 10px, 10px 10px;
    box-shadow: none;
    text-shadow: none;
    transform: scaleX(1) scaleY(1) scaleZ(1);
`;
export const LogoPreview = ({ height, logo, alt, ...props }) => {
    const theme = useTheme();
    const [hovered, setHovered] = useState(false);
    return (_jsxs(LogoBox, { onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), height: height, children: [_jsx(CheckeredBackground, { position: "absolute", top: 0, left: 0, zIndex: -1, margin: "1px", width: "calc(100% - 2px)", height: "calc(100% - 2px)", overflow: "hidden" }), _jsx(CornerPad, { rotation: 0, top: 0, left: 0 }), _jsx(CornerPad, { rotation: 90, top: 0, right: 0 }), _jsx(CornerPad, { rotation: 180, bottom: 0, right: 0 }), _jsx(CornerPad, { rotation: 270, bottom: 0, left: 0 }), _jsx("img", { src: logo, alt: alt, width: "100%", height: "95%", style: { objectFit: 'contain' } }), hovered && (_jsx(Column, { margin: "1px", width: "calc(100% - 2px)", height: "calc(100% - 2px)", position: "absolute", top: 0, left: 0, bg: theme.colors.hoverBlue, opacity: 0.9, justifyContent: "center", alignItems: "center", children: props.children }))] }));
};
//# sourceMappingURL=logo_preview.js.map